const LoginBg = () => {
  return (
    <div className="font-darker h-dvh w-screen px-4 pt-6 text-white">
      <img
        src="/images/login-bg-img.jpg"
        alt=""
        className="absolute inset-0 h-full object-cover"
      />
      <img src="/images/logo.svg" alt="" className="relative mt-4 ml-4" />
      <div className="absolute top-1/2 right-1/2 z-10 w-4/5 min-w-80 translate-x-1/2 -translate-y-1/2 md:w-[600px]">
        <img
          src="/images/login-icon-set.svg"
          className="absolute top-0 right-0 mt-6 md:w-40"
          alt=""
        />
        <img src="/images/login-atm.svg" alt="Atm cards" />{" "}
      </div>
      <h1 className="font-urbanist absolute right-1/2 bottom-5 z-10 w-4/5 min-w-80 translate-x-1/2 pr-12 text-center text-2xl font-bold text-white md:text-7xl md:leading-12">
        Your Wallet, Reinvented, Manage payments, store funds.
      </h1>
    </div>
  );
};

export default LoginBg;
